import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const billDynamicGroupablesUpdateSchema = z.object({
  groupable: z.array(
    z.object({
      id: z.string().optional(),
      products: z.array(optionSchema),
      categories: z.array(optionSchema),
    }),
  ),
});

export type BillDynamicGroupablesUpdateValidationSchema = z.infer<typeof billDynamicGroupablesUpdateSchema>;
